import {useRef} from 'react';
import HomeNav from '../components/LandingPagelib/HomeNav';
import Contact from '../components/LandingPagelib/Contact';
import Footer from '../components/LandingPagelib/Footer';
import ImageSlideshow from '../components/LandingPagelib/ImageSlider';
import MissionCard from '../components/LandingPagelib/MissionCard';
import MobileBanner from '../components/LandingPagelib/mobileBanner';
import PharmServices from '../components/LandingPagelib/Pharm_Services';

const Home = () => {
    const servicesRef = useRef(null)
    const contactRef = useRef(null)
    const homeRef = useRef(null)
    return (
        <div className='bg-white'>
            <HomeNav  contactRef={contactRef} servicesRef={servicesRef}  homeRef={homeRef}/>
            {/* <Hero/>
            <Banner/> */}
            <ImageSlideshow />
            <MobileBanner />
            <MissionCard />
            {/* <Services/> */}
            <div ref={servicesRef}>
                <PharmServices />
            </div>
            <div ref={contactRef}>
                <Contact />
            </div>
            <Footer/>
        </div>
    );
}

export default Home;
